import React from "react";
import Slider from "react-slick";
import { Text } from "../../common/styled";
import mediaQuery from "../../common/mediaQuery";
import "../style.css";

export default ({ text }) => {
  const { small } = mediaQuery();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    className: "SliderContainer",
    slide: "SlidePortifolio",
    appendDots: dots => (
      <ul
        style={{
          margin: "5px",
          backgroundColor: "#22222200",
          paddingTop: 0,
          paddingBottom: 0
        }}
      >
        {" "}
        {dots}{" "}
      </ul>
    ),
    customPaging: () => (
      <div
        style={{
          width: "15px",
          height: "15px",
          backgroundColor: "#ffffff00",
          opacity: 1,
          border: "1px white solid",
          borderRadius: "50%",
          padding: "1px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 2
        }}
      >
        <div
          class="Dot"
          style={{
            border: "0px #ffffff00 solid",
            borderRadius: "50%",
            width: "11px",
            height: "11px",
            opacity: 0,
            backgroundColor: "#fff"
          }}
        />
      </div>
    )
  };

  const portifolio = [
    {
      imagem: require(`../../../images/servicos/sistemas.jpg`),
      texto: text.getTextoHeader()[0]
    },
    {
      imagem: require(`../../../images/servicos/rede.jpg`),
      texto: text.getTextoHeader()[1]
    },
    {
      imagem: require(`../../../images/servicos/sites.jpg`),
      texto: text.getTextoHeader()[2]
    },
    {
      imagem: require(`../../../images/servicos/servidor.jpg`),
      texto: text.getTextoHeader()[3]
    },
    {
      imagem: require(`../../../images/servicos/app.jpg`),
      texto: text.getTextoHeader()[4]
    },
    {
      imagem: require(`../../../images/servicos/seguranca.jpg`),
      texto: text.getTextoHeader()[5]
    },
    {
      imagem: require(`../../../images/servicos/camera.jpg`),
      texto: text.getTextoHeader()[6]
    },
    {
      imagem: require(`../../../images/servicos/sistema_video.jpg`),
      texto: text.getTextoHeader()[7]
    },
  ];

  return (
    <div className="SliderContainer">
      <Slider {...settings}>
        {portifolio.map((obj) => {
          return (
            <div>
              <div
                className="SlideContato"
                style={{
                  backgroundImage: `url(${obj.imagem})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              >
                <div className="SlideTextService" style={small ? {} : {}}>
                  <Text
                    style={{
                      borderLeft: "solid",
                      borderWidth: 3.5,
                      borderColor: "#58b711",
                      paddingLeft: 20,
                      paddingBottom: 10,
                      fontSize: '2.5rem'
                    }}
                    size={small ? "2.5vh" : "5vh"}
                    weight="700"
                    transform="uppercase"
                  >
                    {obj.texto}
                  </Text>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};
